module.exports = {
  controller: require('./home-working-hours.ctrl')
  template: require('./home-working-hours.pug')()
  bindings:
    salon: '<'
    onSubmit: '&'
}
